package com.bulut.mecitogullari

import androidx.compose.animation.Crossfade
import androidx.compose.animation.core.tween
import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.tooling.preview.Preview
import com.bulut.mecitogullari.core.i18n.LocalStrings
import com.bulut.mecitogullari.core.i18n.Localization
import com.bulut.mecitogullari.core.i18n.strings
import com.bulut.mecitogullari.navigation.AppNavigation
import com.bulut.mecitogullari.ui.screens.splash.SplashScreen
import com.bulut.mecitogullari.ui.theme.AppTheme
import kotlinx.coroutines.delay
import kotlin.time.Duration.Companion.milliseconds

private const val SPLASH_DURATION_MS = 1600L

@Composable
@Preview
fun App() {
    val language by Localization.language.collectAsState()
    CompositionLocalProvider(LocalStrings provides language.strings) {
        AppContent()
    }
}

@Composable
private fun AppContent() {
    AppTheme {
        var showSplash by remember { mutableStateOf(true) }

        LaunchedEffect(Unit) {
            delay(SPLASH_DURATION_MS.milliseconds)
            showSplash = false
        }

        // The splash also covers Firebase session restore on cold start.
        Crossfade(
            targetState = showSplash,
            animationSpec = tween(durationMillis = 450),
        ) { splash ->
            if (splash) {
                SplashScreen()
            } else {
                AppNavigation()
            }
        }
    }
}
